import { z } from 'zod';
import { amountMinorSchema, civilDateSchema, currencyCodeSchema, uuidSchema } from './common.js';
import { occurrenceStatusSchema } from './occurrence.js';
export const BANK_FX_SOURCE = 'monobank';
const bankMerchantLinkSchema = z.object({
    id: uuidSchema,
    merchantKey: z.string().min(1),
    description: z.string().min(1),
});
const bankMatchSchema = z.object({
    occurrenceId: uuidSchema,
    operationId: uuidSchema,
    occurredOn: civilDateSchema,
    description: z.string(),
});
export const paymentBankLinksSchema = z.object({
    merchants: z.array(bankMerchantLinkSchema),
    matches: z.array(bankMatchSchema),
});
const linkPeriodSchema = z.object({
    occurrenceId: uuidSchema,
    dueDate: civilDateSchema,
    status: occurrenceStatusSchema.extract(['planned', 'paid']),
    amountMinor: amountMinorSchema.nullable(),
    currency: currencyCodeSchema,
    bankAmountMinor: amountMinorSchema,
    bankCurrency: currencyCodeSchema,
});
const hasPreselectedPeriod = (subscription) => subscription.periods.some((period) => period.occurrenceId === subscription.preselectedOccurrenceId);
const linkSubscriptionSchema = z
    .object({
    paymentId: uuidSchema,
    name: z.string().min(1),
    periods: z.array(linkPeriodSchema).min(1),
    preselectedOccurrenceId: uuidSchema,
})
    .refine(hasPreselectedPeriod, 'the preselected period must be one of the periods');
export const operationLinkOptionsSchema = z.object({
    subscriptions: z.array(linkSubscriptionSchema),
});
export const linkOperationBodySchema = z.object({
    occurrenceId: uuidSchema,
});
//# sourceMappingURL=bank-match.js.map